import React from "react";
import styles from "../ImageWithText/ImageWithText.module.css";
import Animations from "../Animations/animations";

const ImageWithText = ({ aboutContent }) => {
  return (
    <div>
      {aboutContent.map((content, index) => {
        // Set flexDirection based on flexReverse property
        const flexStyle = {
          flexDirection: content.flexReverse === "true" ? "row-reverse" : "row",
        };

        return (
          <div key={index} className={styles.ImageWithText__container}>
            <div className={styles.ImageWithText} style={flexStyle}>
            <Animations animationType="zoomIn" threshold={0.2}>
              <div>
                <img
                  src={content.aboutImage.url}
                  alt={content.aboutImage.alt}
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              </Animations>
              <div>
              <Animations animationType="zoomIn" threshold={0.2}>
                <h3>
                  <span style={{ color: "#1E293B" }}>{content.aboutTitle.title}</span>{" "}
                  {content.aboutTitle.highlightedTitle &&
                    content.aboutTitle.highlightedTitle.trim() !== "" &&
                    content.aboutTitle.highlightedTitle}
                </h3>
                </Animations>
                <Animations animationType="zoomIn" threshold={0.2}>
                <p>{content.aboutDescription}</p>
                </Animations>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageWithText;
